var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 7,
  height: 12,
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.788339 12C0.558143 12 0.369392 11.9256 0.221634 11.7769C0.0738769 11.6609 -1.90735e-06 11.4709 -1.90735e-06 11.2066L-1.90735e-06 0.793381C-1.90735e-06 0.611583 0.0738769 0.421625 0.221634 0.223053C0.369392 0.0743511 0.558143 0 0.788339 0C0.968982 0 1.13341 0.0743511 1.28117 0.223053L6.45448 5.4299C6.6518 5.62802 6.75 5.81797 6.75 6.00023C6.75 6.18157 6.6518 6.37198 6.45448 6.5701L1.28117 11.7769C1.13341 11.9256 0.968982 12 0.788339 12Z",
  fill: "white"
})));
export default SvgIconArrow;